var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "design-layout-components",
    style: {
      left: _vm.isExpand ? "0" : "-238px"
    }
  }, [_vm.componentList.length ? _c("div", {
    staticClass: "template-list"
  }, [_vm._l(_vm.componentList, function (item, i) {
    return [item.componentList.length > 0 ? _c("details", {
      key: item + i,
      staticClass: "components-category",
      attrs: {
        open: ""
      }
    }, [_c("summary", [_vm._v(_vm._s(item.groupName))]), _c("draggable", {
      staticClass: "dragArea components-list",
      attrs: {
        tag: "ul",
        list: item.componentList,
        sort: false,
        filter: ".is-disabled",
        clone: _vm.createCloneComponent,
        group: {
          name: "people",
          pull: "clone",
          put: false
        }
      }
    }, _vm._l(item.componentList, function (c, index) {
      return _c("li", {
        key: index
      }, [_c("a-icon"), _c("span", [_vm._v(_vm._s(c.title))])], 1);
    }), 0)], 1) : _vm._e()];
  })], 2) : _vm._e(), _c("div", {
    staticClass: "expand",
    class: _vm.isExpand == false ? "arrow-right" : "",
    on: {
      click: function click($event) {
        _vm.isExpand = !_vm.isExpand;
      }
    }
  }, [_c("svg", {
    staticClass: "svg-icon icon panel-icon",
    attrs: {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 86",
      "aria-hidden": "true",
      width: "16",
      height: "86"
    }
  }, [_c("g", {
    attrs: {
      fill: "none",
      "fill-rule": "evenodd"
    }
  }, [_c("path", {
    staticClass: "path-wapper",
    attrs: {
      d: "M0 0l14.12 8.825A4 4 0 0116 12.217v61.566a4 4 0 01-1.88 3.392L0 86V0z",
      fill: "#409EFF"
    }
  }), _c("path", {
    staticClass: "path-arrow",
    attrs: {
      d: "M10.758 48.766a.778.778 0 000-1.127L6.996 43l3.762-4.639a.778.778 0 000-1.127.85.85 0 00-1.172 0l-4.344 5.202a.78.78 0 000 1.128l4.344 5.202a.85.85 0 001.172 0z",
      fill: "#fff",
      "fill-rule": "nonzero"
    }
  })])])])]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };